module.exports = __webpack_public_path__ + "img/logo_eng.3937ea32.png";